// file referenced from docs
var hex = /^#[0-9a-fA-F]{3}([0-9a-fA-F]{3})?$/,
    hexa = /^#[0-9a-fA-F]{4}([0-9a-fA-F]{4})?$/,
    hexOrHexa = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/,
    rgb = /^rgb\(((0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),){2}(0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5])\)$/,
    rgba = /^rgba\(((0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),){2}(0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),(0|0\.[0-9]+[1-9]|0\.[1-9]+|1)\)$/;
export var testPattern = {
  date: function date(v) {
    return /^-?[\d]+\/[0-1]\d\/[0-3]\d$/.test(v);
  },
  time: function time(v) {
    return /^([0-1]?\d|2[0-3]):[0-5]\d$/.test(v);
  },
  fulltime: function fulltime(v) {
    return /^([0-1]?\d|2[0-3]):[0-5]\d:[0-5]\d$/.test(v);
  },
  timeOrFulltime: function timeOrFulltime(v) {
    return /^([0-1]?\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/.test(v);
  },
  hexColor: function hexColor(v) {
    return hex.test(v);
  },
  hexaColor: function hexaColor(v) {
    return hexa.test(v);
  },
  hexOrHexaColor: function hexOrHexaColor(v) {
    return hexOrHexa.test(v);
  },
  rgbColor: function rgbColor(v) {
    return rgb.test(v);
  },
  rgbaColor: function rgbaColor(v) {
    return rgba.test(v);
  },
  rgbOrRgbaColor: function rgbOrRgbaColor(v) {
    return rgb.test(v) || rgba.test(v);
  },
  hexOrRgbColor: function hexOrRgbColor(v) {
    return hex.test(v) || rgb.test(v);
  },
  hexaOrRgbaColor: function hexaOrRgbaColor(v) {
    return hexa.test(v) || rgba.test(v);
  },
  anyColor: function anyColor(v) {
    return hexOrHexa.test(v) || rgb.test(v) || rgba.test(v);
  }
};
export default {
  testPattern: testPattern
};